<template>
  <div>
    <section class="fix-header">
      选项内容
      <i
        class="el-icon-circle-plus-outline"
        @click="addOptionsItem"
      />
    </section>
    <section
      v-for="(item, index) in selectVal.addOptions"
      :key="item.value"
      class="fix-list"
    >
      <div class="fix-list__option">
        <el-radio
          v-model="selectVal.defaultValue"
          :label="item.value"
        >
          <el-input
            v-model="item.label"
            placeholder="请输入内容"
          />
        </el-radio>
      </div>
      <div
        class="fix-list__cate"
        @click="deleteOptions(index)"
      >
        <i class="el-icon-delete" />
      </div>
    </section>
  </div>
</template>
<script>
import { getRandwords } from '@/utils'
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SPSelectConfig',
  mixins: [mixin],
  data () {
    return {
      selectVal: {
        addOptions: [],
        defaultValue: ''
      }
    }
  },
  methods: {
    addOptionsItem () {
      this.selectVal.addOptions.push({
        label: '',
        value: `select_id_${getRandwords()}`
      })
    },
    deleteOptions (index) {
      this.selectVal.addOptions.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.fix-header {
  margin-bottom: 15px;
  font-size: 14px;
  .el-icon-circle-plus-outline {
    font-size: 20px;
    color: #409eff;
  }
}
.fix-list {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__option {
    flex: 1;
  }
  &__cate {
    width: 100px;
    z-index: 99;
    .el-icon-delete {
      color: red;
    }
  }
}
</style>
